const getCategoriesThatHaveFood = (
  categories,
  branchId,
  deliveryType,
  foodsMap,
  groupedFoodIdsBasedOnCategory
) => {
  const result = []

  const mainCategories =
    categories
      .filter(c => !c.parentId)
      .filter(category =>
        category.branchIds.includes(branchId)
      )

  mainCategories.forEach(c => {
    const thisCategoryFoodIds =
      groupedFoodIdsBasedOnCategory[c._id]

    if (!thisCategoryFoodIds) return

    const filteredFoods =
      thisCategoryFoodIds.filter(foodId => {
        const food = foodsMap[foodId]

        if (!food) return false

        if (food.onlyThisDeliveries.length === 0) return true

        if (food.onlyThisDeliveries.includes(deliveryType)) return true

        return false
      })

    if (filteredFoods.length === 0) return

    result.push(c)
  })

  return result
}

export default getCategoriesThatHaveFood